<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage">
    </loading>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: 'App',
  components: {
    Loading
  },
  data () {
    return {
      isLoading: true,
      fullPage: true,
      authMode: 'user',
      noLoadiing: ['','/organization', '/createuser', 'createuser','payment', '/organization/signin', '/organization/signup']
    }
  },
  computed: {
    ...mapState({
        loading: state => state.loading
    })
  },
  methods: {
  },
  watch:{
    loading(val){
      this.isLoading = val
    },
    '$route': function (to, from) {
      if (to.path !== from.path) {
        this.$store.commit('setLoading', true)
      }
    }
  },

}
</script>
<style>

@import url("https://fonts.googleapis.com/earlyaccess/notosansjp.css");
#app {
  font-family: 'Lato', 'Noto Sans JP', 'ヒラギノ角ゴ ProN', 'Hiragino Kaku Gothic ProN', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 30px;
}
* :not(.v-icon) {
  font-family: 'Lato', 'Noto Sans JP', 'ヒラギノ角ゴ ProN', 'Hiragino Kaku Gothic ProN', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif !important;
}

</style>
